import React, { PureComponent, Fragment } from "react";

// import ReactEcharts from "echarts-for-react";
import ReactEcharts from "echarts-for-react";

export default class BiaxialLineChart extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      unselectedList: [],
    };
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      option: null,
    }, () => {
      var option = this.parseData(nextProps.data, nextProps.bizYear, nextProps.titleYAxis);
  
      this.setState({
        option: option,
      });
    });
  };

  containsList = (element) => {
    for (var i = 0; i < this.state.unselectedList.length; i++) {
      if (this.state.unselectedList[i] == element) {
        return i;
      }
    }
    return -1;
  };

  parseData = (chartData, year, titleYAxis) => {
    var xAxis = [];
    var series = [];
    var legend = [];
    var stack = [];

    if (chartData) {
      chartData.forEach((data) => {
        if (data.year <= year) {
          xAxis.push(data.year);
        }
      });
      xAxis.sort((a, b) => a - b);
      // chartData.forEach((data) => {
      //   if (data.year <= year) {
      //     data.stat.forEach((stat) => {
      //       const legendName = `${(stat.stack ? stat.stack + '-' : '')}${stat.name}`;
      //       if (!legend.includes(legendName)) {
      //         legend.push(legendName);
      //       }
      //     });
      //   }
      // });
      // legend.forEach((l) => {
      //   series.push({
      //     name: l,
      //     stack: "stack",
      //     list: Array.from(xAxis, () => 0),
      //   });
      // });

      chartData.forEach((dataYear) => {
        if (dataYear.year <= year) {
          dataYear.stat.forEach((stat) => {
            var statIndex = xAxis.indexOf(dataYear.year);
            var s = series.find((s) => {
              if(stat.stack) {
                return s.stack == stat.stack && s.name == stat.name;
              } else {
                return s.name == stat.name;
              }
            });
            if(!s) {
              s = {
                name: stat.name,
                stack: "stack",
                list: Array.from(xAxis, () => 0),
              };
              series.push(s);
            }
            if (stat["stack"]) {
              s.stack = stat["stack"];
            }
            s.list[statIndex] = stat.value;
          });
        }
      });
    }
    series.forEach((s) => {
      if (!stack.includes(s.stack)) {
        stack.push(s.stack);
      }
    });
    var option = {
      grid: {
        left: "15%",
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
        formatter: (params, chart, test) => {
          var tooltipHtml = [];
          var tooltipTitle = "";

          params.forEach((e) => {
            if (!tooltipTitle) tooltipTitle += e.name + "년<br/>";

            if (e.seriesName !== "Sum") {
              var paramData = this.props.data.find((a) => a.year == e.axisValue)
                .stat[e.seriesIndex];
              if (paramData) {
                if (!tooltipHtml.find((a) => a.stack === paramData.stack)) {
                  tooltipHtml.push({ stack: paramData.stack, html: "" });
                }
                var tooltipStack = tooltipHtml.find(
                  (a) => a.stack === paramData.stack
                );
                tooltipStack.html +=
                  e.marker + e.seriesName + " : " + e.value.toLocaleString();
                if (e.componentSubType === "line") tooltipStack.html += " %";

                tooltipStack.html += " <br/>";
              }
            }
          });
          if (tooltipHtml.length == 1) {
            return tooltipTitle + tooltipHtml[0].html;
          } else {
            var tooltip = `<div class='row'>`;
            tooltipHtml.forEach((t) => {
              tooltip += `<div class='col'>${t.stack}<br/>${t.html}</div>`;
            });
            tooltip += `</div>`;

            return tooltip;
          }
        },
      },
      legend: {
        show: false,
        data: legend,
      },
      xAxis: [
        {
          type: "category",
          data: xAxis,
          axisPointer: {
            type: "shadow",
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          name: titleYAxis,
          min: 0,
          axisLabel: {
            formatter: (value) => {
              return value.toLocaleString();
            },
          },
        },
      ],
      series: series.map((s) => {
        return {
          name: s.name,
          type: "bar",
          stack: s.stack,
          data: s.list,
          label: {
            show: false,
            position: "insideTop",
            formatter: (param) => {
              if (param.value === 0) {
                return "";
              } else {
                return param.value.toLocaleString();
              }
            },
          },
        };
      }),
    };
    stack.forEach((s) => {
      option.series.push({
        name: "Sum",
        type: "bar",
        stack: s,
        data: Array.from(xAxis, () => 0),
        color: "#00fff",
        label: {
          show: true,
          position: "top",
          formatter: (params) => {
            let total = 0;
            option.series.forEach((serie) => {
              if (serie.stack == s && this.containsList(serie.name) == -1) {
                total += serie.data[params.dataIndex];
              }
            });
            return total.toLocaleString();
          },
        },
      });
    });
    return option;
  };

  _onEvent = {
    legendselectchanged: (params, chart) => {
      var isSelected = params.selected[params.name];
      var index = this.containsList(params.name);
      if (isSelected) {
        if (index != -1) {
          this.state.unselectedList.splice(index, 1);
        }
      } else {
        if (index == -1) {
          this.state.unselectedList.push(params.name);
        }
      }

      chart.setOption({ animation: true });
    },
  };

  render() {
    const { option } = this.state;

    return option ? (
      <ReactEcharts theme="macarons" style={{width: "100%", height: "100%"}} option={option} onEvents={this._onEvent} />
    ) : (
      <></>
    );
  }
}
